import { Button } from '@sravni/react-design-system';
import { useIsMobile } from '@sravni/react-utils';
import cn from 'classnames';
import type { ReactNode } from 'react';

import { useStickButton } from '../lib/useStickButton';

import styles from './FormStickyButton.module.scss';

type FormStickyButtonProps = {
  enabled: boolean;
  onClick?: () => void;
  ButtonComponent?: ReactNode | null;
};

export const FormStickyButton: FC<FormStickyButtonProps> = ({
  enabled,
  onClick,
  children,
  className,
  ButtonComponent,
}) => {
  const isMobile = useIsMobile();

  const { spaceRef, anchorRef, isStuck, stuckTranslateX } = useStickButton({
    enabled,
    isMobile,
  });

  if (!enabled || !isMobile) {
    return null;
  }

  return (
    <>
      <div
        ref={spaceRef}
        className={cn(
          styles.stickyButtonSpace,
          styles.stickyButtonContainer,
          {
            [styles.isStuck]: isStuck,
          },
          className,
        )}
        // нужно для корректного позиционирования кнопки при скролле,
        // чтобы она крепилась к краю экрана, а не к своему контейнеру и не зависела от его отступов
        style={isStuck ? { transform: `translateX(${stuckTranslateX}px)` } : undefined}
      >
        {ButtonComponent || (
          <Button
            onClick={onClick}
            size={52}
            variant="primary"
            block={isMobile}
          >
            {children}
          </Button>
        )}
      </div>
      <div
        ref={anchorRef}
        className={styles.stickyAnchor}
      />
    </>
  );
};
